/*
 * Add-ons and services are two different tables with two different shapes, but
 * a shopper reads them as one list: "what did I add to this product?". These
 * functions fold both into display items priced in cents.
 */

const toAddonItem = (addon) => ({
  key: `addon-${addon.name}`,
  label: addon.title,
  quantity: 1,
  cents: addon.rawPrice ?? 0,
  texts: [],
});

const withInstance = (group, service) => ({
  ...group,
  quantity: group.quantity + 1,
  cents: group.cents + (service.addonPrice ?? 0),
  texts: service.customerText
    ? [...group.texts, service.customerText]
    : group.texts,
});

/*
 * A service may be added up to its maxQuantity, so "Personal quote" can appear
 * several times over. Rolling repeats into one counted row keeps the list
 * readable, and each instance keeps its own text underneath.
 */
const toServiceItems = (services) =>
  Object.values(
    services.reduce((groups, service) => {
      const key = `service-${service.influencerServiceId}`;

      return {
        ...groups,
        [key]: withInstance(
          groups[key] ?? {
            key,
            label: service.label,
            quantity: 0,
            cents: 0,
            texts: [],
          },
          service,
        ),
      };
    }, {}),
  );

const toSection = (id, label, items) =>
  items.length ? [{ id, label, items }] : [];

export const buildCustomizations = ({ addons = [], services = [] }) => {
  const addonItems = addons.map(toAddonItem);
  const serviceItems = toServiceItems(services);

  return {
    sections: [
      ...toSection("addons", "Add-ons", addonItems),
      ...toSection("services", "Services", serviceItems),
    ],
    count: addons.length + services.length,
    totalCents: [...addonItems, ...serviceItems].reduce(
      (sum, item) => sum + item.cents,
      0,
    ),
  };
};
